import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { LoaderService } from '@shared/components/loader/loader.service';
import { FieldStandardService } from '@app/services/selective-processes/fields/fields-standard.service';
import { ComponentStandardService } from '@app/services/selective-processes/component/component-standard.service';
import { VisualIdentityService } from '@app/services/general-settings/visual-identity/visual-identity.service';
import { PagesService } from '@app/services/pages/pages.service';
import { NotificationService } from '@shared/components/notification/notification.service';
import { Component } from '@app/services/selective-processes/component/component';
import { Fields } from '@app/services/selective-processes/fields/fields';
import { VisualIdentity } from '@app/services/general-settings/visual-identity/visual-identity';
import { Pages } from '@app/services/pages/pages';
interface PageEditorInterface {
  pageData: Pages;
  standardFields: Array<Fields>;
  componentStandard: Array<Component>;
  visualIdentity: VisualIdentity;
}

const dataInit: PageEditorInterface[] = [];
@Injectable({
  providedIn: 'root'
})
export class PagesEditorService {

  private buildTheData = new BehaviorSubject(dataInit);

  public pageEditorData = this.buildTheData.asObservable();
  public checkLoad = false;

  private data: PageEditorInterface;

  public pagesData: any;
  public fields: Array<Fields>;
  public components: Array<Component>;
  public visualIdentity: VisualIdentity;

  constructor(
    public loaderService: LoaderService,
    private fieldStandardService: FieldStandardService,
    private componentStandardService: ComponentStandardService,
    private visualIdentityService: VisualIdentityService,
    private pagesService: PagesService,
    private notificationService: NotificationService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> | Promise<any> | any {


    this.loaderService.setChangesLoaderState(true);

    return this.pagesService.read(route.params.id).toPromise()
      .then(pagesData => this.pagesData = pagesData.data)
      // .then(() => this.getComponent())
      .then((componentsData) => this.components = [])
      .then(() => this.getVisualIdentity())
      .then((visualIdentityData) => this.visualIdentity = visualIdentityData.data)
      .then(() => this.getFields())
      .then((fieldsData) => this.fields = fieldsData)
      .catch(error => this.loaderService.setChangesLoaderState(false, error.body, '', 'error', error.title, 100000))
      .then((error) => {
        if (error) {
          this.loaderService.setChangesLoaderState(false);
          this.data = {
            pageData: this.pagesData,
            standardFields: this.fields,
            componentStandard: this.components,
            visualIdentity: this.visualIdentity
          };
          this.setData(this.data);
          return this.data;
        }
      });
  }


  /**
   * setData
   * @param param Valores para ser usandos no editor.
   */
  public setData(param: any): void {
    this.buildTheData.next(param);
  }

  /**
   * getData
   * Retorna todos os dados setados
   */
  public getData() {
    let dataReturn: PageEditorInterface;
    this.pageEditorData.subscribe(
      (data: any) => {
        dataReturn = data;
      }
    );
    return dataReturn;
  }


  private getFields() {
    return this.fieldStandardService.createArrayNoParam().toPromise();
  }


  private getComponent() {
    return this.componentStandardService.createArrayNoParam().toPromise();
  }

  private getVisualIdentity() {
    return this.visualIdentityService.readBasic().toPromise();
  }

}
